
import 'viewerjs/dist/viewer.css'
import Vue from 'vue'
import VueViewer from 'v-viewer'
import { withRichContentImageAttributes } from '~/utils/richContentImages'

Vue.use(VueViewer, {
  defaultOptions: {
    transition: false,
    zIndex: 1e16,
  },
})

export default {
  name: 'ArticleShow',
  props: {
    article: Object,
  },
  data() {
    return {
      slide: 0,
      interval: 3000,
      '@type': 'NewsArticle',
      headline: this.article.title,
      image: this.article.images?.[0]?.url ?? '/logo_og.png',
      author: {
        '@type': 'Person',
        name: 'AGM Vision',
      },
      publisher: {
        '@type': 'Organization',
        name: 'AGM Vision',
        logo: {
          '@type': 'ImageObject',
          url: '/logo_dark.png',
        },
      },
      datePublished: this.article.created_at,
      dateModified: this.article.updated_at,
      description: this.article.subtitle,
      articleSection: 'Eclairage LED',
      wordCount: (this.article.body ?? '').split(/\s+/).filter(Boolean).length,
      timeRequired: this.calculateReadingTime(this.article.body),
      inLanguage: 'fr-FR',
    }
  },
  computed: {
    articleBody() {
      return withRichContentImageAttributes(this.article.body, {
        fallbackTitle: this.article.title,
        numberedLabel: (title, number) =>
          this.$t('components.articleShow.imageAltNumbered', { title, number }),
      })
    },
    readingTime() {
      return this.calculateReadingTime(this.article.body)
    },
    urlToAdminPage() {
      return `${this.$config.adminUrl}/articles/${this.article.id}`
    },
    isModifiedAfterOneMonth() {
      const createdAt = new Date(this.article.created_at)
      const updatedAt = new Date(this.article.updated_at)
      const oneMonth = 30 * 24 * 60 * 60 * 1000
      return updatedAt - createdAt > oneMonth
    },
  },
  methods: {
    calculateReadingTime(body) {
      const text = (body ?? '').replace(/<[^>]*>/g, '')
      const wordCount = text.split(/\s+/).filter(Boolean).length
      const wordsPerMinute = 250
      const readingTime = wordCount / wordsPerMinute
      return Math.ceil(readingTime)
    },
  },
}
